import FittingStationStore from '../../_flux/stores/fitting_station_store';
import ActiveStationStore from '../../_flux/stores/active_station_store';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';
import PageTypeFactory from '../../page/get_page_type';

const analyticStates = {
    initialOpen: true
};

class FittingStationFinderAnalytics {
    static sendOpenAction() {
        const $container = $('.page-container');
        const category = GA_EVENTS.fittingStationFinder.category;
        const action = analyticStates.initialOpen ?
            GA_EVENTS.fittingStationFinder.actions.initialOpen :
            GA_EVENTS.fittingStationFinder.actions.open;
        const label = PageTypeFactory.getPageType($container);

        setBehaviourEvent({ category, action, label });
        analyticStates.initialOpen = false;
    }

    static sendActiveStationChanged() {
        const allStations = FittingStationStore.getState().stations;
        const newActiveStation = ActiveStationStore.getState().activeStation;
        const newActiveStationListNum = allStations.findIndex(x=>x.id === newActiveStation.id) + 1;
        const category = GA_EVENTS.fittingStationFinder.category;
        const action = GA_EVENTS.fittingStationFinder.actions.stationSelect;
        const label = `Position in List: ${newActiveStationListNum}`;

        setBehaviourEvent({ category, action, label });
    }
}

export default FittingStationFinderAnalytics;